import React from "react";

import { ICellRendererParams } from "@ag-grid-community/core";

import { UserRef } from "@mapmycustomers/shared/types/User";

import UserCellRenderer from "@app/component/grid/gridComponents/cellRenderers/UserCellRenderer";

const UserNameCellRenderer: React.FC<ICellRendererParams> = (props) => {
  if (!(props.value as UserRef).fullName) {
    // Wrapping into fragment because this component can't return a plain string.
    // On the other hand it can't return `null` because that's an AgGrid recommendation
    // to return empty strings: https://www.ag-grid.com/react-hooks/#react-null
    return <>{""}</>;
  }

  return <UserCellRenderer {...props} />;
};

export default UserNameCellRenderer;
